import React from 'react';
import classNames from 'classnames/bind';
import { useHistory } from "react-router-dom";
import { Space } from '@masterteam/mt-design-react';

import useIsAr from '../../Hooks/useIsAr';
import { ReactComponent as ArrowIcon } from '../../assets/images/sub-arrow.svg';
import styles from './Breadcrumb.module.scss';

const cx = classNames.bind(styles);

function Breadcrumb({
  data,
  size = 'small',
  fontSize = 'var(--font-medium)',
  endContent = null
}) {
  const [isAr] = useIsAr();
  const history = useHistory()

  if (!data?.length) return null;

  return (
    <Space
      align="center"
      size={size}
      className={`${styles.breadcrumb} breadcrumb-container`}
      style={{ '--font-size': fontSize }}
    >
      <Space className="breadcrumb">
        {data.map((item, index) => {
          const isElement = React.isValidElement(item);
          return (
            <React.Fragment key={isElement ? item.key : item?.ID || index}>
              <span className={styles.text}
              onClick={() => {
                return item?.path ? history.push(item?.path) : null;
              }}
              style={{ cursor: item?.path ? "pointer" : "" }}>
                {isElement ? item : isAr ? item?.ArabicName : item?.EnglishName}
              </span>
              <span
                className={cx({
                  arrow: true,
                  rtl: isAr
                })}
              >
                <ArrowIcon />
              </span>
            </React.Fragment>
          );
        })}
      </Space>
      <Space>{endContent}</Space>
    </Space>
  );
}

export default Breadcrumb;
